import { createFileRoute, Link } from '@tanstack/react-router'
import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { Box, Button, Stack, Typography } from '@mui/material'
import { faSearch } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ParseKeys } from 'i18next'

export const Route = createFileRoute('/_auth/404')({
  component: RouteComponent,
  validateSearch: z.object({
    reason: z.string().optional(),
  }),
})

function RouteComponent() {
  const { reason } = Route.useSearch()
  const { t } = useTranslation()

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Box sx={{ display: 'inline-flex' }}>
        <Typography
          variant="h1"
          sx={{
            color: 'rgba(64, 64, 64, 0.5)',
            fontSize: 104,
            fontWeight: 'bold',
          }}
        >
          4
        </Typography>
        <Box sx={{ padding: '15px 0 10px 5px' }}>
          <Box
            sx={{
              height: 80,
              width: 80,
              backgroundColor: 'rgba(64, 64, 64, 0.5)',
              borderRadius: '50%',
              fontSize: 40,
              textAlign: 'center',
              color: 'white',
              padding: '15px',
              marginLeft: '10px',
              marginRight: '10px',
            }}
          >
            <FontAwesomeIcon icon={faSearch} />
          </Box>
        </Box>
        <Typography
          variant="h1"
          sx={{
            color: 'rgba(64, 64, 64, 0.5)',
            fontSize: 104,
            fontWeight: 'bold',
          }}
        >
          4
        </Typography>
      </Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t([`unknownRoute.${reason}.title` as ParseKeys, 'unknownRoute.title'])}
      </Typography>
      <Typography variant="body2">
        {t([`unknownRoute.${reason}.body.line1` as ParseKeys, 'unknownRoute.body.line1'])}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {t([`unknownRoute.${reason}.body.line2` as ParseKeys, 'unknownRoute.body.line2'])}
      </Typography>
      <Button component={Link} to="/" variant="contained" color="primary">
        {t([`unknownRoute.${reason}.back` as ParseKeys, 'unknownRoute.back'])}
      </Button>
    </Stack>
  )
}
